import e, { useState as m, useEffect as f } from "react";
import _ from "./index132.mjs";
import r from "./index192.mjs";
import { AllocateGuests as x } from "./index193.mjs";
import { CollapsedExtras as N } from "./index194.mjs";
import { useTracking as y } from "./index88.mjs";
import { EXTRA_SELECTION_ROOM_HASH as C } from "./index87.mjs";
import { useSummaryButton as S } from "./index155.mjs";
import { track as T } from "./index9.mjs";
import { TRACK_EVENT_TYPE as b, TRACK_EVENT as A } from "./index10.mjs";
import { useHotelConfig as R } from "./index93.mjs";
import { getSubscriptionPlanRoot as v } from "./index14.mjs";
const B = ({
  cartItem: t,
  isFirst: d,
  removeRoom: l
}) => {
  const { setSummaryButton: s } = S();
  y(C, {
    roomNumber: t.id.toString()
  });
  const [a, i] = m(!1), [o, n] = m(!0), { hotelId: p, propertySize: E, propertyType: c, subscriptionPlan: u } = R();
  return f(() => {
    i(!o), s({
      disabled: o
    });
  }, [o, s]), /* @__PURE__ */ e.createElement(
    "div",
    {
      "data-testid": "room-with-extras-step",
      className: r.extras_container
    },
    /* @__PURE__ */ e.createElement("div", { className: r.header }, /* @__PURE__ */ e.createElement("div", { "data-testid": "room-title", className: r.title }, t.id, ". ", t.roomName), d ? null : /* @__PURE__ */ e.createElement("div", { className: r.delete_room }, /* @__PURE__ */ e.createElement(
      _,
      {
        "data-testid": "delete-room",
        onClick: () => {
          T(A.CLICK, b.CLICK_ON_DELETE, {
            hotel_id: p,
            property_type: c,
            property_size: E,
            subscription_plan: v(u)
          }), l(t.id);
        }
      }
    ))),
    /* @__PURE__ */ e.createElement("div", { className: r.body }, /* @__PURE__ */ e.createElement(
      x,
      {
        cartItem: t,
        isExpanded: o,
        setIsExpanded: () => {
          n(!o);
        }
      }
    ), /* @__PURE__ */ e.createElement(
      N,
      {
        cartItem: t,
        isDisabled: o,
        isExpanded: a,
        setIsExpanded: () => {
          i(!a);
        }
      }
    ))
  );
};
export {
  B as RoomWithExtrasStep
};
